import {
    getApplications,
    useEnvironment,
    ClientRepresentation,
    usePromise,
    Page,
} from "@keycloak/keycloak-account-ui";
import {
    PageSection,
    Spinner,
} from "@patternfly/react-core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ExtendedGroup, getGroupsExtended } from "../api/methods";


type Application = ClientRepresentation & {
    open: boolean;
};

export const CustomApplications = () => {
    const { t } = useTranslation();
    const context = useEnvironment();

    const [applications, setApplications] = useState<Application[]>();
    const [clientIds, setClientIds] = useState<Set<string> | null>();

    usePromise(
        (signal) => getApplications({ signal, context }),
        (clients) => setApplications(clients.map((c) => ({ ...c, open: false }))),
    );

    usePromise(
        (signal) => getGroupsExtended({ signal, context }).catch((error) => {
            console.warn("Unable to load group client ids; showing all applications.", error);
            return null;
        }),
        (groups) => setClientIds(groups === null ? null : getClientIds(groups)),
    );

    if (!applications || clientIds === undefined) {
        return <Spinner />;
    }

    return (
        <Page title={t("applications")} description={""}>
            <PageSection isFilled>
                <div className="row">
                    {applications.map((application) => {
                        if (clientIds === null || clientIds.has(application.clientId)) {
                        return (
                            <div key={application.clientId} className="col-md-4 cm-application-tile" id={application.clientId}>

                                <div className="cm-application-tile-inner">
                                    <a href={application.effectiveUrl}>
                                        <div className="cm-application-img-wrapper">
                                        </div>
                                        <div className="cm-app-name">
                                            {application.clientName}
                                        </div>
                                    </a>
                                </div>
                            </div>
                        )}
                    })}
                </div>
            </PageSection>
        </Page>
    );
};

function getClientIds(groups: ExtendedGroup[]): Set<string> {
    return new Set(
        groups.flatMap((group) => {
            const clientIds = group.attributes?.["client-ids"];
            const values = Array.isArray(clientIds) ? clientIds : [];

            return values
                .flatMap((value) => value.split(","))
                .map((value) => value.trim())
                .filter(Boolean);
        }),
    );
}

export default CustomApplications;
